import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// Bespoke Azure VNet Peering — white-on-transparent interlocking rings,
// same geometry as `awsVpcPeering` / `gcpVpcPeering`. Matches the Azure
// family style (`azureVnet`, `azureNic`, `azureSubnet`, …); not a trace
// of the Microsoft architecture glyph (NIM-21654 licensing).
function createAzureVnetPeeringIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path fill-rule="evenodd" clip-rule="evenodd" d="M25 13.5C28.5899 13.5 31.5 16.4102 31.5 20C31.5 23.5899 28.5899 26.5 25 26.5C21.4102 26.5 18.5 23.5899 18.5 20C18.5 16.4102 21.4102 13.5 25 13.5ZM25 15.25C22.3766 15.25 20.25 17.3766 20.25 20C20.25 22.6234 22.3766 24.75 25 24.75C27.6234 24.75 29.75 22.6234 29.75 20C29.75 17.3766 27.6234 15.25 25 15.25Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 13.5C18.5899 13.5 21.5 16.4102 21.5 20C21.5 23.5899 18.5899 26.5 15 26.5C11.4102 26.5 8.5 23.5899 8.5 20C8.5 16.4102 11.4102 13.5 15 13.5ZM15 15.25C12.3766 15.25 10.25 17.3766 10.25 20C10.25 22.6234 12.3766 24.75 15 24.75C17.6234 24.75 19.75 22.6234 19.75 20C19.75 17.3766 17.6234 15.25 15 15.25Z" fill="white"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const azureVnetPeeringIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAzureVnetPeeringIcon,
);
